export default __webpack_public_path__ + "static/media/awaiting.83fa8498.svg";